import { Component, Input, ViewChild } from '@angular/core';
import {
    NavController,
    NavParams
} from 'ionic-angular';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { Rodeo } from '../../../../model/rodeo';
import { E } from '@angular/core/src/render3';

@Component({
    selector: 'page-roster-report',
    templateUrl: 'report-roster.html'

})
export class RosterReport {
    @Input('rodeo') rodeo: Rodeo;
    @ViewChild('rosterContainer') rosterContainer;
    @ViewChild('pageBreak') pageBreak;

    selectedRodeoEvent: RodeoEvent;
    contestants: any[];
    contestantMap: Map<number, any>;
    documentTitle: any;

    schedules: any[];

    headerHeight: number;
    teamRowHeight: number;

    popoverActive: boolean;
    dataLoaded: boolean;

    printing: boolean;

    constructor(private nav: NavController, private navParams: NavParams) {
        if (!this.rodeo)
            this.rodeo = navParams.get('rodeo');

        this.selectedRodeoEvent = navParams.get('selectedRodeoEvent');
        this.printing = navParams.get('printing');

        this.contestants = [];
        this.contestantMap = new Map<number, any>();

        if (this.rodeo) {
            if (!this.selectedRodeoEvent)
                this.selectedRodeoEvent = this.rodeo.rodeoEvents[0];

            this.updateRodeoEvent();
        }

        setTimeout(() => {
            this.load();
        }, 0);
    }

    load() {
        this.documentTitle = this.rodeo.name + " - " + 'Roster';
        this.dataLoaded = true;
    }

    matchRodeoEvents(a, b) {
        return a.id == b.id;
    }

    updateRodeoEvent() {
        this.contestants = [];
        this.schedules = [];
        this.contestantMap = new Map<number, any>();

        let selectedSchedule = this.selectedRodeoEvent.schedules[0];

        this.schedules = this.selectedRodeoEvent.schedules;

        if (selectedSchedule.scheduleGroupId && selectedSchedule.scheduleGroupId != 0) {
            this.schedules = this.rodeo.rodeoEvents.flatMap(x => x.schedules)
                .filter(x => x.scheduleGroupId == selectedSchedule.scheduleGroupId)
        }

        for (let h = 0; h < this.schedules.length; h++) {
            let teams = this.schedules[h].runs.filter(item => item.round == 1);

            for (let i = 0; i < teams.length; i++) {
                if (!this.contestantMap.has(teams[i].contestantOneId)) {
                    this.addAndSortContestant(teams[i].contestantOne);
                }

                if (teams[i].contestantTwo) {
                    if (!this.contestantMap.has(teams[i].contestantTwoId)) {
                        this.addAndSortContestant(teams[i].contestantTwo);
                    }
                }
            }
        }
    }

    addAndSortContestant(roper) {
        var itemToSwap = roper;
        this.contestantMap.set(itemToSwap.id, itemToSwap);

        for (let h = 0; h < this.contestants.length; h++) {
            if (itemToSwap.lastName.toLowerCase() < this.contestants[h].lastName.toLowerCase()) {
                let oldItem = this.contestants[h];
                this.contestants[h] = itemToSwap;
                itemToSwap = oldItem;
            } else if (itemToSwap.lastName.toLowerCase() === this.contestants[h].lastName.toLowerCase()) {
                if (itemToSwap.firstName < this.contestants[h].firstName) {
                    let oldItem = this.contestants[h];
                    this.contestants[h] = itemToSwap;
                    itemToSwap = oldItem;
                }
            }
        }

        this.contestants.push(itemToSwap);
    }

    getContestantRuns(scheduleIndex, roper) {
        return this.schedules[scheduleIndex].runs.filter((team) => team.round == 1 && (team.contestantOneId === roper.id || team.contestantTwoId === roper.id));
    }

    ionViewDidEnter() {
        setTimeout(() => {
            window.document.title = this.documentTitle;
            window.print();
            this.nav.pop();
        }, 0);
    }

    print() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.nav.push(RosterReport, {
            rodeo: this.rodeo,
            selectedRodeoEvent: this.selectedRodeoEvent,
            printing: true
        }).then(() => { this.popoverActive = false; });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-roster.ts